import camelCase from 'lodash/camelCase';

export default function getQueryField(prefix: string, hasLocalNews: boolean) {
  const queryField = hasLocalNews
    ? `${camelCase(prefix)}Category`
    : 'category';

  return queryField;
}
